'use strict';

/**
 * Array of Breakpoints in order from smallest to largest
 */
var BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];

/**
 * Constant definitions of built-in breakpoints.
 */

exports.BREAKPOINTS = BREAKPOINTS;
//# sourceMappingURL=breakpoints-5748ddd8.js.map
